export default __webpack_public_path__ + "static/media/summer_22.2f4446de.pdf";